export enum PaymentType {
  PAY_1X = "PAY_1X",
  PAY_NX = "PAY_NX",
  PAY_ND = "PAY_ND",
}
